// import Cookies from 'js-cookie';

const TokenKey = 'BJ-Token';
const AdminTokenKey = 'BJ-Admin-Token';
const ImpersonationKey = 'BJ-Impersonation';

export function getToken() {
  // return Cookies.get(TokenKey);
  return localStorage.getItem(TokenKey);
}

export function setToken(token) {
  // return Cookies.set(TokenKey, token);
  return localStorage.setItem(TokenKey, token);
}

export function getAdminToken() {
  return localStorage.getItem(AdminTokenKey);
}

export function setAdminToken(token) {
  return localStorage.setItem(AdminTokenKey, token);
}

export function removeAdminToken() {
  return localStorage.removeItem(AdminTokenKey);
}

export function getImpersonationInfo() {
  const value = localStorage.getItem(ImpersonationKey);
  if (!value) return null;
  try {
    return JSON.parse(value);
  } catch (e) {
    return null;
  }
}

export function setImpersonationInfo(info) {
  return localStorage.setItem(ImpersonationKey, JSON.stringify(info || {}));
}

export function removeImpersonationInfo() {
  return localStorage.removeItem(ImpersonationKey);
}

export function removeToken() {
  // return Cookies.remove(TokenKey);
  sessionStorage.clear();
  removeAdminToken();
  removeImpersonationInfo();
  return localStorage.removeItem(TokenKey);
}
